import api from "@/api/index"
import endpoints from "@/api/endpoints"
import fileDownload from "js-file-download"

export const saveFile = async (path: string = "test_data", file: File[]) => {
  let formdata = new FormData()

  file.map((item) => formdata.append("files", item))

  return api.post(endpoints.UPLOAD_FILE(path), formdata)
}

export const downloadFile = async (path: string) => {
  return await api
    .get(endpoints.FETCH_FILE(path), {
      responseType: "blob",
    })
    .then((res) =>
      fileDownload(res.data, path.split("/").at(-1) || "download___aurin"),
    )
}
